// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_pagination-container__UnpoP {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--m-border, #eee);
  background: var(--m-card-background-color, white);
  position: relative;
  z-index: 0;
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-info__qW0UA {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--m-text-light, #495057);
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-info__qW0UA select {
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid var(--m-border, #ced4da);
  border-radius: 4px;
  background-color: var(--m-card-background-color, #fff);
  color: var(--m-text, #495057);
  cursor: pointer;
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-info__qW0UA select:focus {
  outline: none;
  border-color: var(--bs-primary);
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 {
  display: flex;
  gap: 0.5rem;
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 button {
  padding: 0.375rem 0.75rem;
  border: 1px solid var(--m-border, #ced4da);
  background: var(--m-card-background-color, white);
  border-radius: 4px;
  cursor: pointer;
  color: var(--m-text-light, #495057);
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 button:hover:not(:disabled) {
  background: var(--m-surface-subtle, #f8f9fa);
  border-color: var(--m-border, #adb5bd);
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 button:focus {
  outline: none;
  border-color: var(--bs-primary);
}
@media (max-width: 768px) {
  .Pagination_pagination-container__UnpoP {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .Pagination_pagination-container__UnpoP .Pagination_pagination-info__qW0UA {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .Pagination_pagination-container__UnpoP .Pagination_pagination-actions__zCri9 {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Pagination/Pagination.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;AACJ;AACI;EACE,0CAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,sDAAA;EACA,6BAAA;EACA,eAAA;AACN;AACM;EACE,aAAA;EACA,+BAAA;AACR;AAIE;EACE,aAAA;EACA,WAAA;AAFJ;AAII;EACE,yBAAA;EACA,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFN;AAIM;EACE,4CAAA;EACA,sCAAA;AAFR;AAKM;EACE,YAAA;EACA,mBAAA;AAHR;AAMM;EACE,aAAA;EACA,+BAAA;AAJR;AASE;EAlEF;IAmEI,sBAAA;IACA,SAAA;IACA,oBAAA;EANF;EAQE;IACE,sBAAA;IACA,mBAAA;IACA,kBAAA;EANJ;EASE;IACE,uBAAA;EAPJ;AACF","sourcesContent":[".pagination-container {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--m-border, #eee);\n  background: var(--m-card-background-color, white);\n  position: relative;\n  z-index: 0;\n\n  .pagination-info {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    color: var(--m-text-light, #495057);\n\n    select {\n      padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n      font-size: 0.875rem;\n      border: 1px solid var(--m-border, #ced4da);\n      border-radius: 4px;\n      background-color: var(--m-card-background-color, #fff);\n      color: var(--m-text, #495057);\n      cursor: pointer;\n\n      &:focus {\n        outline: none;\n        border-color: var(--bs-primary);\n      }\n    }\n  }\n\n  .pagination-actions {\n    display: flex;\n    gap: 0.5rem;\n\n    button {\n      padding: 0.375rem 0.75rem;\n      border: 1px solid var(--m-border, #ced4da);\n      background: var(--m-card-background-color, white);\n      border-radius: 4px;\n      cursor: pointer;\n      color: var(--m-text-light, #495057);\n      min-width: 36px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 1rem;\n\n      &:hover:not(:disabled) {\n        background: var(--m-surface-subtle, #f8f9fa);\n        border-color: var(--m-border, #adb5bd);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      &:focus {\n        outline: none;\n        border-color: var(--bs-primary);\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n\n    .pagination-info {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n\n    .pagination-actions {\n      justify-content: center;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination-container": `Pagination_pagination-container__UnpoP`,
	"pagination-info": `Pagination_pagination-info__qW0UA`,
	"pagination-actions": `Pagination_pagination-actions__zCri9`
};
export default ___CSS_LOADER_EXPORT___;
